<style>
  hr {
    border-bottom: 1px solid var(--tui-background-neutral-1-hover);
  }
  .extend-width {
    width: calc(100% + 2rem);
    margin-left: -1rem;
  }
</style>
@let isInsideSummary = $isInsideSummary();
@let fileCatGroups = fileCatGroups$ | async;

<ng-template #tooltip>
  <div class="text-xs">
    {{ 'request_form.files.download.tooltip' | translate }}
  </div>
</ng-template>

<ng-template
  #downloadLink
  let-link="link"
  let-withoutHr="withoutHr"
  let-withDownload="withDownload"
  let-createdViaApi="createdViaApi"
>
  @let linkName =
    createdViaApi
      ? ('request_form.files.download.file_links_names.created_with_api'
          | translate) + link.name
      : link.langId
        ? ('request_form.files.download.file_links_names.' + link.langId
          | translate)
        : link.name;

  <p class="typo-body-m font-medium py-4.5">
    @if (withDownload) {
      <a
        [href]="link.href || null"
        (click)="
          isRequestLinkDisabled(link) ||
            (!link.href && $event.preventDefault());
          !isRequestLinkDisabled(link) && link.click?.($event);
          !isRequestLinkDisabled(link) &&
            link.href &&
            handleFileLinkClick($event, link.href, link.filename)
        "
        class="underline"
        [ngClass]="{
          'cursor-not-allowed opacity-50 pointer-events-none':
            isRequestLinkDisabled(link),
        }"
        [attr.download]="link.href ? '' : null"
        rel="noopener noreferrer"
        referrerpolicy="no-referrer"
        >{{ linkName }}
      </a>
    } @else {
      <a
        [href]="link.href || null"
        (click)="
          isRequestLinkDisabled(link) ||
            (!link.href && $event.preventDefault());
          !isRequestLinkDisabled(link) && link.click?.($event);
          !isRequestLinkDisabled(link) &&
            link.href &&
            handleFileLinkClick($event, link.href, link.filename)
        "
        class="underline"
        [ngClass]="{
          'cursor-not-allowed opacity-50 pointer-events-none':
            isRequestLinkDisabled(link),
        }"
        target="_blank"
        rel="noopener noreferrer"
        referrerpolicy="no-referrer"
        >{{ linkName }}
      </a>
    }
  </p>
  @if (!withoutHr) {
    <hr [ngClass]="{ 'extend-width': !isInsideSummary }" />
  }
</ng-template>

<ng-template
  #templateGenerate
  let-templateName="templateName"
  let-click="click"
  let-langId="langId"
>
  <p class="typo-body-m font-medium py-4.5">
    <a
      (click)="click()"
      class="underline cursor-pointer"
      [ngClass]="{ 'cursor-not-allowed': isGenerating() }"
    >
      {{
        langId
          ? ('request_form.files.download.file_links_names.' + langId
            | translate)
          : templateName
      }}
    </a>
  </p>
</ng-template>

<section class="mt-8" [tuiSkeleton]="!!((isLoading$ | async) && isInitialLoad)">
  @if (permissionService.canViewOtherFileGroups$ | async) {
    <section class="mt-3">
      <h6 class="typo-h6 pb-4.5">
        {{ 'request_form.files.download.request_docs_title' | translate }}
      </h6>
      <hr [ngClass]="{ 'extend-width': !isInsideSummary }" />
      @for (link of requestLinks(); track link.name) {
        <ng-container
          [ngTemplateOutlet]="downloadLink"
          [ngTemplateOutletContext]="{
            link,
            withDownload: link.href?.endsWith('download=1'),
          }"
        />
      }
    </section>
    <section class="mt-8">
      <h6 class="typo-h6 pb-4.5">
        {{ 'request_form.files.download.download_docs_title' | translate }}
      </h6>
      <hr [ngClass]="{ 'extend-width': !isInsideSummary }" />
      @for (generateDocLink of generateDocsLinks; track generateDocLink.name) {
        <ng-container
          [ngTemplateOutlet]="downloadLink"
          [ngTemplateOutletContext]="{
            link: generateDocLink,
            withDownload: true,
          }"
        />
      }
      @if (permissionService.canDownloadAlfaActs$ | async) {
        @for (alfaLink of linksWithAlfaLogic; track alfaLink.name) {
          <ng-container
            [ngTemplateOutlet]="downloadLink"
            [ngTemplateOutletContext]="{
              link: alfaLink,
              withDownload: true,
            }"
          />
        }
      }
      @for (fileCat of $createdViaApiFileCats(); track fileCat.id) {
        @let apiFileCat = resolveFileCatCreatedWithApi(fileCat);
        @if (apiFileCat) {
          <ng-container
            [ngTemplateOutlet]="downloadLink"
            [ngTemplateOutletContext]="{
              link: apiFileCat,
              withDownload: true,
              createdViaApi: true,
            }"
          />
        }
      }
    </section>
    @if (templatesOfActs.length) {
      <section class="mt-8">
        <h6 class="typo-h6 pb-4.5">
          {{ 'request_form.files.download.generate_docs_title' | translate }}
        </h6>
        <hr [ngClass]="{ 'extend-width': !isInsideSummary }" />
        @for (template of templatesOfActs; track template.name) {
          <ng-container
            [ngTemplateOutlet]="templateGenerate"
            [ngTemplateOutletContext]="{
              templateName: template.name,
              click: template.click,
            }"
          />
        }
        <ng-container
          [ngTemplateOutlet]="templateGenerate"
          [ngTemplateOutletContext]="{
            templateName: 'Сгенерировать все',
            click: generateAllActs.bind(this),
            langId: 'generate_all_acts',
          }"
        />
      </section>
    }
    <section>
      <h6 class="typo-h6 mt-8 pb-4.5">
        {{ 'request_form.files.download.groups_title' | translate }}
      </h6>

      <tui-accordion size="m" [ngClass]="{ 'extend-width': !isInsideSummary }">
        <button tuiAccordion>
          <ng-container
            [ngTemplateOutlet]="downloadLink"
            [ngTemplateOutletContext]="{
              link: {
                name: 'Все файлы заявки',
                langId: 'all_request_files',
                href: getFileCatGroupDownloadLink(10000),
              },
              withoutHr: true,
              withDownload: true,
            }"
          />
        </button>
        <tui-expand class="no-y-padding-accordion-btn">
          <ol
            class="list-decimal ps-5 typo-body-s leading-5 text-(--tui-text-primary) marker:text-(--tui-text-tertiary)"
          >
            @for (category of $fileCats(); track category.id) {
              <li
                class="mt-3 first:mt-0 wrap-break-word x-text-02 text-xs font-semibold opacity-80"
              >
                {{ category.name }}
              </li>
            }
          </ol>
        </tui-expand>

        @for (fcGroup of fileCatGroups; track fcGroup.id) {
          <button
            tuiAccordion
            tuiHintAppearance="dark"
            tuiHintDirection="top"
            [tuiHint]="tooltip"
          >
            <ng-container
              [ngTemplateOutlet]="downloadLink"
              [ngTemplateOutletContext]="{
                link: {
                  name: fcGroup.name,
                  href: getFileCatGroupDownloadLink(fcGroup.id),
                },
                withoutHr: true,
                withDownload: true,
              }"
            />
          </button>
          <tui-expand class="no-y-padding-accordion-btn">
            <ol
              class="list-decimal ps-5 typo-body-s leading-5 text-(--tui-text-primary) marker:text-(--tui-text-tertiary)"
            >
              @for (category of fcGroup.fileCats; track category.id) {
                <li
                  class="mt-3 first:mt-0 wrap-break-word x-text-02 text-xs font-semibold opacity-80"
                >
                  {{ category.name }}
                </li>
              }
            </ol>
          </tui-expand>
        }
      </tui-accordion>
    </section>
    <x-request-files-send-by-email
      [fileCatGroups]="fileCatGroups || []"
      [isInsideSummary]="isInsideSummary"
    />
  } @else {
    <div class="x-card__title text-center text-(--x-color-danger)">
      {{ 'request_form.files.download.no_permission' | translate }}
    </div>
  }
</section>
